import decodeToken from "./decodeToken";

// Espelha Lila.Domain/Enums/EProfessionalRole.cs
export const ProfessionalRole = {
  Default: 0,
  UnitAdmin: 1,
  InstitutionAdmin: 2
};

export default function professionalProfile(token){
  let decoded = decodeToken(token);
  let role = decoded ? Number(decoded.ProfessionalRole) : NaN;

  return role === ProfessionalRole.UnitAdmin || role === ProfessionalRole.InstitutionAdmin
    ? "professional_leader"
    : "professional_default";
}
